import Flatpickr from "stimulus-flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";

/**
 * GO4LEARN — le sélecteur de DATE, repris de GO4SCHOOL.
 *
 * ## 🔴 Pourquoi un contrôleur de plus alors que `flatpickr_controller` existe
 *
 * Il existe, il est bon, et il est **inatteignable d'ici** : `entrypoints/controllers/index.js`
 * l'enregistre sur l'instance Stimulus de la suite GO4SCHOOL, et **aucun paquet `learn*` ne
 * charge ce fichier**. `learn_console.js` démarre sa PROPRE `Application`. C'est exactement le
 * défaut mesuré au navigateur le 2026-09-20 : l'assistant d'annales habillait bien ses
 * sélecteurs — donc le JS tournait — et sa cascade ne partait jamais, sans une erreur en
 * console. Poser `data-controller="flatpickr"` sur un écran GO4LEARN ne ferait donc
 * strictement rien.
 *
 * ⚠️ **Ce qu'il fait de PLUS, et c'est sa seule raison d'être** : il marque le calendrier
 * d'une classe. `flatpickr` déplace son calendrier à la racine du `<body>`, hors de
 * `.g4l-page` — aucun sélecteur descendant ne l'atteint, et le thème vert de la suite
 * resterait vert sur une console magenta.
 *
 * ⚠️ **`altInputClass` recopie la classe du champ natif.** `altInput: true` fabrique un
 * SECOND champ, visible, et masque l'original ; sans cette ligne il naît nu et perd le
 * `g4l-field` de la console. C'est le piège déjà payé sur SlimSelect, qui exige la même
 * recopie de classe.
 */
export default class extends Flatpickr {
  static values = {
    minDate: String,
    maxDate: String,
    enableTime: { type: Boolean, default: false },
    dateFormat: { type: String, default: "Y-m-d" },
  };

  initialize() {
    this.config = {
      locale: French,
      time_24hr: true,
      altInput: true,
      altFormat: this.enableTimeValue ? "d/m/Y H:i" : "d/m/Y",
      // ⚠️ La valeur POSTÉE reste ISO : le champ visible est une décoration, le serveur lit
      // toujours `Y-m-d`. Changer ce format changerait ce que le contrôleur reçoit.
      dateFormat: this.dateFormatValue,
      enableTime: this.enableTimeValue,
      allowInput: true,
      monthSelectorType: "dropdown",
      altInputClass: this.element.className,
      onReady: (_dates, _str, picker) => {
        picker.calendarContainer.classList.add("g4l-flatpickr");
      },
    };

    if (this.hasMinDateValue) this.config.minDate = this.minDateValue;
    if (this.hasMaxDateValue) this.config.maxDate = this.maxDateValue;
    if (this.element.value) this.config.defaultDate = this.element.value;
  }

  connect() {
    // ⚠️ Turbo rejoue `connect` sur une page restaurée depuis son cache, et une seconde
    // instance sur le même champ laisse deux calendriers superposés.
    if (this.element._flatpickr) this.element._flatpickr.destroy();
    super.connect();
  }
}
